// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';

const WarrantyExpirationDealerCriteria = props => {

    const dealerSelectionMessage = props.selectedDealers.length > 0 ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (
        <div className='warranty-expiration-dealer-criteria'>
            <CheckboxListWithLabel
                className='warranty-expiration-dealers'
                initialState={createHashMap(props.selectedDealers, 'account')}
                isRequired={true}
                label='DEALER_LOCATION'
                list={addCollectionLabels(props.allowedAccounts)}
                onChange={props.onDealerSelectClick}
                uid='account'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllDealers}
                type='button'
            >
                <FormattedMessage id={dealerSelectionMessage}/>
            </button>
        </div>);

};

WarrantyExpirationDealerCriteria.displayName = 'WarrantyExpirationDealerCriteria';
WarrantyExpirationDealerCriteria.propTypes = {
    allowedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    onDealerSelectClick: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default WarrantyExpirationDealerCriteria;




// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/components/warranty-expiration-dealer-criteria.js